import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse, SitterJobFilter } from '../types';

const URL = '/v2/sitter-job-filters';

class SitterJobFilterService {
  static getByFilter(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<SitterJobFilter>> {
    return axios.get(URL, config);
  }

  static create(
    data: SitterJobFilter,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<SitterJobFilter>> {
    return axios.post(URL, data, config);
  }

  static update(
    id: number,
    data: SitterJobFilter,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<SitterJobFilter>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }
}

export { SitterJobFilterService };
